import React from 'react';
import classNames from 'classnames';
import { NativeProps } from '@/src/components/interfaces';

export enum CLoaderSize {
  Button = 'button',
  Xs = 'xs',
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg'
}

export enum CLoaderColor {
  White = 'white',
  Accent1 = 'accent-1',
  Accent2 = 'accent-2',
  Accent3 = 'accent-3',
  Accent4 = 'accent-4',
  Accent5 = 'accent-5',
  Accent6 = 'accent-6',
}

export interface CLoaderProps extends NativeProps {
  size?: CLoaderSize;
  color?: CLoaderColor;
}

export function CLoader(props: CLoaderProps): React.JSX.Element {
  const size = props.size ?? CLoaderSize.Md;
  const color = props.color ?? CLoaderColor.Accent1;

  return (
    <span
      data-test-selector="c-loader"
      className={classNames(
        'c-loader',
        `c-loader--size-${size}`,
        `c-loader--color-${color}`,
        props.class,
      )}
    />
  );
}